/**
 * `true` when the `window` EXACTLY matches an existing pick — same
 * start AND same end. Used by the click reducer to swallow a click that
 * would create a visually-identical duplicate slot.
 *
 * Deliberately NOT containment: a SMALLER window that sits inside a
 * larger existing slot (e.g. a 5-min pick clicked inside an existing
 * 15-min slot after the recruiter shortens the Duration) is a distinct,
 * intentional slot and MUST be created. The old `fullyCoveredBy`
 * containment guard swallowed those clicks, so shortening the duration
 * over pre-existing slots silently created nothing. This matches the
 * module's `OVERLAP_POLICY = 'exact-match-dedup'` (different starts /
 * sizes coexist as siblings; only identical picks dedup).
 */
import type { SelfSlot } from '../types';
import { toMs } from './toMs';

export function isExactDuplicate(
  window: { startMs: number; endMs: number },
  slots: SelfSlot[],
  timezone: string
): boolean {
  for (const slot of slots) {
    if (
      toMs(slot.start, timezone) === window.startMs &&
      toMs(slot.end, timezone) === window.endMs
    ) {
      return true;
    }
  }
  return false;
}
